import { IResourceComponentsProps, useForm } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";
import Cw8EditWrapper from "components/cw8/Cw8EditWrapper";
import { ChildForm } from "interfaces/schemaDB";

export const SubsectionPubsEdit: React.FC<IResourceComponentsProps> = () => {
    // return <AntdInferencer />;

    const resourceLabel :string = 'Subsección';
    const resourceName :string = 'subsectionPub';
    const { id } = useForm();
    const childrenForms : ChildForm[] =[
        
    {
        resourceName :"fragmentPub",
        title : "Fragmentos",
        field : "frs_id_subsection"
    },
    ]

    return(
        <Cw8EditWrapper
            resourceLabel = {resourceLabel}
            resourceName = {resourceName}
            id = {id}
            childrenForms = {childrenForms}
        ></Cw8EditWrapper>
    )    
};
